<template>
  <transition
    @before-enter="before_enter"
    @enter="enter"
    @after-enter="after_enter"
    @before-leave="before_leave"
    @leave="leave"
    @after-leave="after_leave"
  >
    <slot />
  </transition>
</template>

<script>
export default {
  name: "v-transition",
  props: {
    name: {
      type: String,
      default: "fade",
    },
    delay: {
      type: Number,
      default: 400,
    },
    duration: {
      type: Number,
      default: 680,
    },
    easing: {
      type: String,
      default: "easeInOut",
    },
  },
  data() {
    return {
      options: {},
    };
  },
  methods: {
    before_enter(el) {
      $(el).addClass("animateEnter").addClass("beforeAnimate");
      this.name === "fade" && $(el).css("opacity", "0");
    },
    enter(el, done) {
      if (this.name === "fade") {
        setTimeout(() => {
          $(el)
            .velocity("stop")
            .velocity(
              { opacity: 1 },
              {
                duration: this.duration,
                easing: this.easing,
                display: $(el).css("display"),
                complete: done,
              }
            );
        }, this.delay);
      }
      this.name === "attach-reactive" && this._attach_reactive_enter(el, done);
    },
    after_enter(el) {
      $(el)
        .removeClass("animateEnter")
        .removeClass("beforeAnimate")
        .removeClass("out-animate")
        .removeClass("out-up")
        .removeClass("out-down")
        .attr("style", "");
    },
    before_leave(el) {
      $(el).addClass("animateLeave").addClass("beforeAnimate");
    },
    leave(el, done) {
      //    动画在enter中做了
      if (this.name === "fade") {
        $(el)
          .velocity("stop")
          .velocity("fadeOut", {
            duration: this.duration,
            easing: this.easing,
            delay: this.delay,
            complete: () => {
              done();
              setTimeout(() => {
                window?.paintViewer?.destroy?.();
              }, 300);
            },
          });
      }

      this.name === "attach-reactive" && this._attach_reactive_leave(el, done);
    },
    after_leave(el) {},
    async _attach_reactive_leave(el, done) {
      let imgData = window.paintViewer.imageData;
      let imgSlug = window.paintViewerImageData.imageSlug;
      let imgSrc = window.paintViewerImageData.imageMax;
      let targetEl = $(`.right-image-float-box [data-slug="${imgSlug}"]`).get(
        0
      );
      if (targetEl === undefined) {
        targetEl = $(`.picture-wall-card div[data-slug=${imgSlug}]`).get(0);
      }
      let targetRect = targetEl.getBoundingClientRect();
      let img = document.createElement("img");
      img.id = "photo-img-fixed-return";
      img.src = imgSrc;
      $(img).css({
        width: imgData.width,
        height: imgData.height,
        top: imgData.top,
        left: imgData.left,
        position: "fixed",
        zIndex: 9999999,
        opacity: 1,
      });
      $(document.body).append(img);
      window?.paintViewer?.destroy?.();
      $(".v-paint-viewer .viewer-container").remove();
      $(".v-paint-viewer").velocity("fadeOut");
      document.body.classList.remove("viewer-open");
      document.body.classList.remove("disabled-scroll");
      $(img).css({ objectFit: "cover", objectPosition: "50% 50%" });
      $(img).velocity(
        {
          width: targetRect.width,
          height: targetRect.height,
          top: targetRect.top,
          left: targetRect.left,
        },
        {
          complete: () => {
            done();
            $(img).remove();
          },
        }
      );
    },
    _attach_reactive_enter(el, done) {
      $(el).css("opacity", 0);
      $(window).one("_calcImgSizeAndPositionDone", async (ev, payload) => {
        //    1 获取图片slug + 找到对应图片
        let imgSlug = payload.imageSlug;
        //    这里需要注意, 点击进入元素需要有slug
        //    https://i.imgur.com/r2npZoB.jpg
        let mdImageTarget = $(
          `.right-image-float-box [data-slug="${imgSlug}"]`
        );
        if (mdImageTarget.length === 0) {
          mdImageTarget = $(`.picture-wall-card div[data-slug=${imgSlug}]`);
        }
        //    2. 创建一个元素
        let img = document.createElement("img");
        img.id = "photo-img-fixed";
        img.src = payload.image;
        //  3. 设置其对应位置
        let { width, height, top, left } = mdImageTarget
          .get(0)
          .getBoundingClientRect();
        $(img).css({
          width,
          height,
          top,
          left,
          position: "fixed",
          zIndex: 9999999,
          borderRadius:
            mdImageTarget.parents(".right-image-float-box").length > 0 ? 8 : 0,
        });

        //   4. 塞入body 让其重叠
        $(document.body).append(img);
        $(img).css({ objectFit: "cover", objectPosition: "50% 50%" });

        $(el).velocity("fadeIn", { duration: this.duration / 2 });
        $(el).addClass("fade-in");

        //  5. 执行放大动画
        $(img).velocity(
          {
            width: payload.width,
            height: payload.height,
            top: payload.top,
            left: payload.left,
            borderRadius: 0,
          },
          {
            duration: this.duration,
            complete: () => {
              $(el).addClass("fade-in-done");
              $(img).remove();
              done();
              $(window).trigger("attach_reactive_enter_animate_ended");
            },
          }
        );
      });
    },
  },
};
</script>

<style lang="scss">
.beforeAnimate {
  position: fixed !important;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.animateEnter {
  z-index: 1000;
}

.animateLeave {
  z-index: 1010;
}

.out-animate {
  will-change: transform;
  transition: transform 1s ease 0ms;

  &.out-up {
    transform: translate3d(0, 0, 0) !important;
  }

  &.out-up-leave {
    transform: translate3d(0, -100vh, 0) !important;
  }

  &.out-down {
    transform: translate3d(0, 0, 0) !important;
  }

  &.out-down-leave {
    transform: translate3d(0, 100vh, 0) !important;
  }
}

.v-leave-to {
  .stage-animate2 {
    animation: none;
  }
}

.notOverflow {
  overflow: hidden !important;
  height: 100vh !important;
  max-height: 100vh !important;
}
</style>
